import React from 'react'
import Header from "../components/Header";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";
export default function ReturnPage() {
    return (
        <div>
            <Header />
            <Breadcrumb />
            <Footer />
        </div>
    )
}
